import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';
import { Box } from '@mui/system';
import { API_PATH } from 'common/constants/services';
import useMutation, { METHOD } from 'hook/useMutation';
import useQuery from 'hook/useQuery';
import PartsList from 'pages/parts/PartsList';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

interface IProps {
  isOpen: boolean;
  workout: Workout | null;
  partId: number;
  close: () => void;
  onSuccessModify: () => void;
}

interface IFormValue {
  workoutsText: string;
}

type TMutation = { part_id?: number; name?: string };

export function WorkoutModifyModal({
  close,
  isOpen,
  workout,
  partId,
  onSuccessModify,
}: IProps) {
  const { register, getValues, reset, setValue } = useForm<IFormValue>();
  const inputRef = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [selectedParts, setSelectedParts] = useState(partId);

  const handleCloseModal = () => {
    close();
  };

  const partQuery = useQuery<PartResponse>(API_PATH.PARTS);
  const patchWorkoutQuery = useMutation<TMutation>(
    `${API_PATH.WORKOUTS}${workout?.id}/`,
    {
      method: METHOD.PATCH,
      onSuccess: () => {
        toast.success('수정이 완료되었습니다.');
        reset();
        onSuccessModify();
        handleCloseModal();
      },
    },
  );

  const onClickSave = () => {
    if (window.confirm('저장하시겠습니까?')) {
      const { workoutsText } = getValues();
      let param: TMutation = {};

      if (partId !== selectedParts) {
        param = {
          ...param,
          part_id: selectedParts,
        };
      }

      if (workout?.name !== workoutsText) {
        param = {
          ...param,
          name: workoutsText,
        };
      }

      patchWorkoutQuery.mutate(param);
    }
  };

  useEffect(() => {
    if (workout) {
      setValue('workoutsText', workout.name);
    }
  }, [workout, setValue]);

  return (
    <Dialog
      keepMounted
      open={isOpen}
      onClose={handleCloseModal}
      aria-labelledby='keep-mounted-modal-title'
      aria-describedby='keep-mounted-modal-description'
    >
      <DialogContent>
        <PartsList
          selectedParts={selectedParts}
          setSelectedParts={setSelectedParts}
          input={inputRef}
          parts={partQuery.getQuery.data?.data.results || []}
          size='small'
        />
        <Box
          sx={{
            width: { xs: '100%', md: '50%' },
          }}
        >
          <form onSubmit={(e) => e.preventDefault()}>
            <TextField
              fullWidth
              type='text'
              placeholder='workout'
              inputRef={inputRef}
              {...register('workoutsText', { required: true })}
              autoFocus
            />
          </form>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleCloseModal}>
          취소
        </Button>
        <Button variant='contained' color='success' onClick={onClickSave}>
          적용
        </Button>
      </DialogActions>
    </Dialog>
  );
}
